export const ORG = "org"
export const ASSO = "asso"
